import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/email.png';
import _imports_1 from '../assets/tip.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_2 = { class: "onlyTallScreen" };
const _hoisted_3 = { class: "anchor-bottom centered" };
const _hoisted_4 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_5 = { class: "anchor-bottom" };
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useApi } from '@/composables/useApi';
import { useWhatsApp } from '@/composables/useWhatsApp';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CreateAccountPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { registerCustomer, verifyEmail } = useCustomer();
        const { login } = useApi();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const { enableWhatsApp } = useWhatsApp({ whatsAppPromoCard: null, whatsAppEnableDrawer: null, whatsAppNumber: '' });
        const registerUser = ref(null);
        const regError = ref(false);
        const pinError = ref(false);
        const code = ref(null);
        const loggingIn = ref(false);
        const error = ref(false);
        async function onLoad() {
            let stored = localStorage.getItem('registerUser');
            if (!stored) {
                router.push({ path: '/getstarted' });
                return;
            }
            registerUser.value = JSON.parse(stored);
            // Ensure phone number is in the format +447429386911
            if (!registerUser.value.phone.startsWith('+44')) {
                registerUser.value.phone = '+44' + registerUser.value.phone.replace(/^0/, '');
            }
            console.log(registerUser.value);
            const address = {
                postCode: registerUser.value.postCode
            };
            const customer = {
                person: {
                    firstName: registerUser.value.firstName,
                    lastName: registerUser.value.lastName,
                    mobilePhone: registerUser.value.phone,
                    email: registerUser.value.email,
                    dob: registerUser.value.dob,
                    addresses: [address]
                },
                employerID: registerUser.value.employerId,
            };
            console.log(customer, 'Customer to register');
            let token = cookies?.get('token');
            if (token) {
                customer.token = token;
            }
            if (registerUser.value.email === 'test@mock.com') {
                state.customer = { person: { email: 'test@mock.com' } };
                return;
            }
            registerCustomer(customer, registerUser.value.password, token, (r) => {
                cookies?.remove('token');
                console.log(r, 'Register customer result');
                if (r.success == true) {
                    state.customer = r.customer;
                    cookies?.set('user', registerUser.value.email, '1m');
                    cookies?.set('pass', registerUser.value.password, '1m');
                    localStorage.removeItem('registerUser');
                }
                else {
                    console.log(r.message);
                    regError.value = r.message;
                }
            });
        }
        function verifyCode() {
            if (registerUser.value.email === 'test@mock.com') {
                cookies?.set('user', 'test@mock.com', '1m');
                cookies?.set('pass', 'mockpassword', '1m');
                router.push({ path: '/setpin' });
                return;
            }
            verifyEmail(state.customer.person.email, code.value, (r) => {
                if (r.success == true) {
                    login(registerUser.value.email, registerUser.value.password, () => {
                        loggingIn.value = true;
                        // If they chose to enable whatsapp on the phone number screen, do it
                        // now as we now have the customer object
                        if (registerUser.value.enableWhatsApp) {
                            enableWhatsApp();
                        }
                        router.push({ path: '/setpin' });
                    });
                }
                else {
                    console.log(r.message);
                    pinError.value = true;
                    code.value = null;
                }
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_otp_input = _resolveComponent("v-otp-input");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer || error.value
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Verify your email", -1)),
                                _cache[5] || (_cache[5] = _createElementVNode("img", {
                                    class: "heroImg",
                                    src: _imports_0
                                }, null, -1)),
                                _createElementVNode("p", _hoisted_2, "Please check the email we have sent to " + _toDisplayString(registerUser.value?.email), 1),
                                _cache[6] || (_cache[6] = _createElementVNode("p", null, "Please enter the 6 digit code you were emailed. (Don't forget to check your Junk/Spam folders.)", -1)),
                                _createVNode(_component_v_otp_input, {
                                    class: "codeField",
                                    modelValue: code.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((code).value = $event)),
                                    type: "number",
                                    variant: "solo",
                                    flat: true,
                                    "single-line": "",
                                    "bg-color": "#ffffffaa"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_3, [
                                    (!loggingIn.value)
                                        ? (_openBlock(), _createBlock(MGButton, {
                                            key: 0,
                                            text: "Verify",
                                            alt: true,
                                            onClick: verifyCode,
                                            arrow: true
                                        }))
                                        : _createCommentVNode("", true),
                                    (loggingIn.value)
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 1,
                                            size: "30",
                                            width: "3",
                                            indeterminate: ""
                                        }))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (regError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _cache[10] || (_cache[10] = _createElementVNode("h1", null, "Sorry, we ran into a problem", -1)),
                                _cache[11] || (_cache[11] = _createElementVNode("img", {
                                    class: "heroImg",
                                    src: _imports_1
                                }, null, -1)),
                                _createElementVNode("p", null, [
                                    _cache[7] || (_cache[7] = _createTextVNode("We are sorry, something went wrong, please contact support. The technical detail was: ")),
                                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                    _createElementVNode("code", null, _toDisplayString(regError.value), 1)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(MGButton, {
                                        text: "Try again",
                                        alt: true,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).push({ path: '/personaldetails' }))),
                                        arrow: true
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (pinError.value)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 0,
                        "max-width": "500",
                        modelValue: pinError.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((pinError).value = $event))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, null, {
                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("Invalid Code")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode("Are you sure you entered the code correctly?")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                                onClick: _cache[2] || (_cache[2] = ($event) => (pinError.value = false))
                                            }, {
                                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                    _createTextVNode("Try Again")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
